import { useLocation } from 'react-router-dom';

export type Tab = 'partners' | 'clients' | 'analytics';

export const useActiveTab = (): Tab | undefined => {
  const location = useLocation();

  if (location.pathname.includes('/partners')) return 'partners';
  if (location.pathname.includes('/clients')) return 'clients';
  if (location.pathname.includes('/analytics')) return 'analytics';

  return undefined;
};
